<app-card titleKey="profile.personalInfo">
  @if (genericStore.allLoaded() && store.user()?.personalData) {
    <app-profile-edit [formGroup]="personDataFormGroup" />
  }
</app-card>
<div class="d-flex justify-content-end gap-2 px-4 py-4">
  <app-button
    [label]="'general.cancel' | translate"
    variant="default"
    (clicked)="cancelEdit()"
  />
  <app-button
    [iconClass]="'fas fa-save'"
    [label]="'general.save' | translate"
    btnClass="btn btn-primary btn-sm action-btn"
    (clicked)="save()"
    [disabled]="personDataFormGroup.invalid"
  />
</div>
